import { isNullOrUndefined } from '@as-react/common-utils';
import { findOrCreateElementInHead } from './HtmlElementUtil';
import { generateAbsoluteUrl } from './URLParamUtil';
export const generateRelatedProductPageLinks = (canonicalUrl, currentPage, totalPages, updateCanonicalLinkElement = true) => {
    var _a, _b;
    const linkPrevDomElement = findOrCreateElementInHead('link[rel="prev"]', 'link', { rel: 'prev' });
    const linkNextDomElement = findOrCreateElementInHead('link[rel="next"]', 'link', { rel: 'next' });
    if (updateCanonicalLinkElement) {
        const linkCanonicalDomElement = findOrCreateElementInHead('link[rel="canonical"]', 'link', {
            rel: 'canonical',
        });
        if (!isNullOrUndefined(linkCanonicalDomElement)) {
            linkCanonicalDomElement.href = generateAbsoluteUrl(canonicalUrl, currentPage);
        }
    }
    if (!isNullOrUndefined(linkPrevDomElement)) {
        if (currentPage > 0) {
            const prevPage = currentPage - 1;
            linkPrevDomElement.href = generateAbsoluteUrl(canonicalUrl, prevPage);
        }
        else {
            (_a = linkPrevDomElement.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(linkPrevDomElement);
        }
    }
    if (!isNullOrUndefined(linkNextDomElement)) {
        if (currentPage < totalPages - 1) {
            const nextPage = currentPage + 1;
            linkNextDomElement.href = generateAbsoluteUrl(canonicalUrl, nextPage);
        }
        else {
            (_b = linkNextDomElement.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(linkNextDomElement);
        }
    }
};
